$(document).ready(function() {
  var chartSeries = $('.job-chart-pc').attr('data-chart-series');
  var chartHorizontal = $('.horizontal-chart').attr('data-chart-series');
  var chartNumberProjects = $('.number_of_projects').attr('data-number_of_projects');
  var chartNumberRemoteProjects = $('.number_of_remote_projects').attr('data-number_of_remote_projects');
  var chartAverageUnitPrice = $('.average_unit_price').attr('data-average_unit_price');
  var chartIncomeTransition = $('.assumed_annual_income_transition').attr('data-assumed_annual_income_transition');

  drawJobsChartPC(chartSeries);
  drawHorizontalChart(chartHorizontal);
  drawLineChartPC(chartNumberProjects, 'number_of_projects');
  drawLineChartPC(chartNumberRemoteProjects, 'number_of_remote_projects');
  drawLineChartPC(chartAverageUnitPrice, 'average_unit_price');
  drawLineChartPC(chartIncomeTransition, 'assumed_annual_income_transition');
})

function drawJobsChartPC(chartSeries) {
  if(chartSeries === 'null' || chartSeries === undefined) {
    return false;
  }
  chartSeries = JSON.parse(chartSeries)
  var data = Object.values(chartSeries), dataEmpty = true;
  let biggest = Math.max(...data);
  for (var i = 0; i < data.length; i++) {
    if(data[i] != 0){
      dataEmpty = false;
      break;
    }
  }

  var maxValue = data.reduce(function(a, b) {
    return Math.max(a, b);
  });

  var stepSize = dataEmpty ? 1 : Math.max(Math.round(maxValue/50)*10, 1);

  var $chartWrap = document.getElementById('jobs-chart-pc');
  $chartWrap.innerHTML = "<canvas id='jobs-chart-canvas-pc' height='260px'></canvas>";
  var ctx = document.getElementById('jobs-chart-canvas-pc').getContext('2d');

  Chart.pluginService.register({
    beforeDraw: function (chart, easing) {
      if (chart.config.options.chartArea && chart.config.options.chartArea.backgroundColor) {
        var ctx = chart.chart.ctx;
        var chartArea = chart.chartArea;

        ctx.save();
        ctx.fillStyle = chart.config.options.chartArea.backgroundColor;
        ctx.fillRect(chartArea.left, chartArea.top, chartArea.right - chartArea.left, chartArea.bottom - chartArea.top);
        ctx.restore();
      }
    }
  });

  var options = {
    hover: {
      animationDuration: 0
    },
    animation: {
      duration: 1,
    },
    responsive: true,
    maintainAspectRatio: false,
    chartArea: {
      backgroundColor: '#fff'
    },
    scales: {
      xAxes: [{
        gridLines: {
          display: false
        }
      }],
      yAxes: [{
        ticks: {
          suggestedMax: biggest+stepSize,
          stepSize: stepSize,
          display: true
        }
      }]
    },
    legend: {
      display: false,
    },
  }

  function largestIndex(array){
    var max = 0;
    for(var i = 0; i < array.length; i++){
      if(array[max] < array[i]){
          max = i;
      }
    }
    return max;
  }

  function dataChart() {
    var objData = [];
    const data = [
      chartSeries[30],
      chartSeries[40],
      chartSeries[50],
      chartSeries[60],
      chartSeries[70],
      chartSeries[80],
      chartSeries[90],
      chartSeries[100]
    ]
    for (let i = 0; i < data.length; i++) {
      objData.push({
        dataChart: data[i],
        backgroundColor: i == largestIndex(data)? '#005044': '#009d88',
        borderColor: i == largestIndex(data)? '#005044': '#009d88',
      })
    }
    return objData;
  }

  var myChart = new Chart(ctx, {
    type: 'bar',
    options: options,
    data: {
      labels: [
        '30万~',
        '40万~',
        '50万~',
        '60万~',
        '70万~',
        '80万~',
        '90万~',
        '100万~'
      ],
      datasets: [{
        label: '',
        data: dataChart().map(e => e.dataChart),
        backgroundColor: dataChart().map(e => e.backgroundColor),
        borderColor: dataChart().map(e => e.borderColor),
        borderWidth: 1
      }]
    },
  });
}

function drawHorizontalChart(chartSeries) {
  if(chartSeries === 'null' || chartSeries === undefined) {
    return false;
  }
  chartSeries = JSON.parse(chartSeries)
  var data = Object.values(chartSeries), dataEmpty = true;
  let biggest = Math.max(...data);
  for (var i = 0; i < data.length; i++) {
    if(data[i] != 0){
      dataEmpty = false;
      break;
    }
  }

  var maxValue = data.reduce(function(a, b) {
    return Math.max(a, b);
  });

  var stepSize = dataEmpty ? 1 : Math.max(Math.round(maxValue/50)*10, 1);

  var $chartWrap = document.getElementById('horizontal-chart');
  $chartWrap.innerHTML = "<canvas id='horizontal-chart-canvas'></canvas>";
  var ctx = document.getElementById('horizontal-chart-canvas').getContext('2d');

  Chart.pluginService.register({
    beforeDraw: function (chart, easing) {
      if (chart.config.options.chartArea && chart.config.options.chartArea.backgroundColor) {
        var ctx = chart.chart.ctx;
        var chartArea = chart.chartArea;

        ctx.save();
        ctx.fillStyle = chart.config.options.chartArea.backgroundColor;
        ctx.fillRect(chartArea.left, chartArea.top, chartArea.right - chartArea.left, chartArea.bottom - chartArea.top);
        ctx.restore();
      }
    }
  });

  var options = {
    hover: {
      animationDuration: 0
    },
    animation: {
      duration: 1,
    },
    responsive: true,
    maintainAspectRatio: false,
    chartArea: {
      backgroundColor: '#fff'
    },
    scales: {
      xAxes: [{
        gridLines: {
          display: false
        }
      }],
      yAxes: [{
        ticks: {
          suggestedMax: biggest+stepSize,
          stepSize: stepSize,
          display: true
        }
      }]
    },
    legend: {
      display: false,
    },
  }

  var myChart = new Chart(ctx, {
    type: 'horizontalBar',
    options: options,
    data: {
      labels: Object.keys(chartSeries),
      datasets: [{
        label: '',
        data: data,
        backgroundColor: "#009d88",
        borderColor: "#009d88",
        borderWidth: 1
      }]
    },
  });
}

function drawLineChartPC(chartLine, nameChart) {
  if(chartLine === 'null' || chartLine === undefined) {
    return false;
  }
  chartLine = JSON.parse(chartLine);
  var data = Object.values(chartLine), dataEmpty = true;
  let biggest = Math.max(...data);
  for (var i = 0; i < data.length; i++) {
    if(data[i] != 0){
      dataEmpty = false;
      break;
    }
  }

  var maxValue = data.reduce(function(a, b) {
    return Math.max(a, b);
  });

  var stepSize = dataEmpty ? 1 : Math.max(Math.round(maxValue/50)*10, 1);

  var $chartWrap = document.getElementById(nameChart);
  $chartWrap.innerHTML = `<canvas id='line-${nameChart}' width='240px'></canvas>`;
  var ctx = document.getElementById('line-'+nameChart).getContext('2d');

  Chart.pluginService.register({
    beforeDraw: function (chart, easing) {
      if (chart.config.options.chartArea && chart.config.options.chartArea.backgroundColor) {
        var ctx = chart.chart.ctx;
        var chartArea = chart.chartArea;

        ctx.save();
        ctx.fillStyle = chart.config.options.chartArea.backgroundColor;
        ctx.fillRect(chartArea.left, chartArea.top, chartArea.right - chartArea.left, chartArea.bottom - chartArea.top);
        ctx.restore();
      }
    }
  });

  var options = {
    hover: {
      animationDuration: 0
    },
    animation: {
      duration: 1,
    },
    chartArea: {
      backgroundColor: '#fff'
    },
    responsive: true,
    scales: {
      xAxes: [{
        gridLines: {
          display: false
        }
      }],
      yAxes: [{
        ticks: {
          suggestedMax: biggest+stepSize,
          stepSize: stepSize,
          display: true
        }
      }]
    },
    legend: {
      display: false
    },
  }

  var myChart = new Chart(ctx, {
    type: 'line',
    options: options,
    data: {
      labels: Object.keys(chartLine),
      datasets: [{
        label: '',
        data: data,
        pointBackgroundColor: '#009d88',
        borderColor: '#009d88',
        tension: 0.1,
        fill: false
      }]
    },
  });
}
